export default "/assets/topographic-83d0589f11ee6cc066b70cc351209134cae33a614b0006a29f92ceb35a336122.png";